import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';

@Component({
  selector: 'app-eyemdl',
  templateUrl: './eyemdl.component.html',
  styleUrls: ['./eyemdl.component.css']
})
export class EyemdlComponent implements OnInit {
  @Input() benID:any
  @Input() AlraedyDataAdded:any

  examinationForm: FormGroup;
  glassesList: any = [];
  lidList: any=[];
  conjunctiveList: any=[];
  corneaList: any=[];
  acList: any=[];
  pupilList: any=[];
  lensList: any=[];
  forPrescritionData:any
  constructor(public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.forminIt(); this.GlassesData(); this.lensData(); this.PupilData(); this.AcData(); this.CorneaData();
    this.ConjunctivaData(); this.LidData();
if(this.AlraedyDataAdded){
  setTimeout(() => {
    this.examinationForm.patchValue(this.AlraedyDataAdded)
  }, 500);
}


  }

  forminIt() {
    this.examinationForm = this.fb.group({
      vr_glasses_id: [null],
      vr_lid_id: [null],
      vr_conjuctiva_id: [null],
      vr_cornea_id: [null],
      vr_ac_id: [null],
      vr_pupil_id:[null],
      vr_lens_id:[null],
      vr_vitreous:[null],
      vr_fundus:[null],
      vr_iop:[null],
      vr_retina:[null],
      vl_glasses_id: [null],
      vl_lid_id: [null],
      vl_conjuctiva_id: [null],
      vl_cornea_id: [null],
      vl_ac_id: [null],
      vl_pupil_id:[null],
      vl_lens_id:[null],
      vl_vitreous:[null],
      vl_fundus:[null],
      vl_iop:[null],
      vl_retina:[null],
      beneficiary_id:this.benID
    });
  }
  GlassesData() {
    this.regService.get(`masters/getmasterglasses`).subscribe(res => {
      if (res?.status === "OK") {
        if (res?.data == null || res?.data.length == 0) {
          this.toastr.info('No records available');
          this.glassesList = [];
        }
        else
          this.glassesList = res.data;
      }
    },
      error => { this.toastr.error(error.message); }
    );
  }
  LidData() {
    this.regService.get(`masters/getmasterlid`).subscribe(res => {
      if (res?.status === "OK") {
        if (res?.data == null || res?.data.length == 0) {
          this.toastr.info('No records available');
          this.lidList = [];
        }
        else
          this.lidList = res.data;
      }
    },
      error => { this.toastr.error(error.message); }
    );
  }
  ConjunctivaData() {
    this.regService.get(`masters/getmasterconjuctiva`).subscribe(res => {
      if (res?.status === "OK") {
        if (res?.data == null || res?.data.length == 0) {
          this.toastr.info('No records available');
          this.conjunctiveList = [];
        }
        else
          this.conjunctiveList = res.data;
      }
    },
      error => { this.toastr.error(error.message); }
    );
  }

  CorneaData() {
    this.regService.get(`masters/getmastercornea`).subscribe(res => {
      if (res?.status === "OK") {
        if (res?.data == null || res?.data.length == 0) {
          this.toastr.info('No records available');
          this.corneaList = [];
        }
        else
          this.corneaList = res.data;
      }
    },
      error => { this.toastr.error(error.message); }
    );
  }

  AcData() {
    this.regService.get(`masters/getmasteranteriorchamber`).subscribe(res => {
      if (res?.status === "OK") {
        if (res?.data == null || res?.data.length == 0) {
          this.toastr.info('No records available');
          this.acList = [];
        }
        else
          this.acList = res.data;
      }
    },
      error => { this.toastr.error(error.message); }
    );
  }

  PupilData() {
    this.regService.get(`masters/getmasterpupli`).subscribe(res => {
      if (res?.status === "OK") {
        if (res?.data == null || res?.data.length == 0) {
          this.toastr.info('No records available');
          this.pupilList = [];
        }
        else
          this.pupilList = res.data;
      }
    },
      error => { this.toastr.error(error.message); }
    );
  }

  lensData() {
    this.regService.get(`masters/getmasterlens`).subscribe(res => {
      if (res?.status === "OK") {
        if (res?.data == null || res?.data.length == 0) {
          this.toastr.info('No records available');
          this.lensList = [];
        }
        else
          this.lensList = res.data;
      }
    },
      error => { this.toastr.error(error.message); }
    );
  }

  numberValidator(control: AbstractControl) {
    const value = control.value;
    // Match +ve/-ve number with optional decimal (up to 2 decimal places)
    const regex = /^[-+]?(\d{1,2}(\.\d{1,2})?|20(\.00?)?)$/;

    if (!regex.test(value)) {
      return { invalidNumber: true };
    }

    const numericValue = parseFloat(value);
    if (numericValue < -20 || numericValue > 20) {
      return { outOfRange: true };
    }

    return null;
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  keyPressAlphabets(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressAlphaNumeric(event) {
    //  var inp = String.fromCharCode(event.keyCode);
    var inp = event.key;
    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  onSave(){
    this.forPrescription();
    this.toastr.success("Records Saved After POC Submition")
    let data={
      "examinationForm" : this.examinationForm ,
      "forPrescritionData" : this.forPrescritionData
    }
    setTimeout(() => {
      this.activeModal.close(data)
    }, 200);
   
  }

  forPrescription(){
    this.forPrescritionData={
        vr_glasses_id : this.glassesList.find( (e: any) => e.id == this.examinationForm.value.vr_glasses_id)?.name || '',
        vr_lid_id :  this.lidList.find( (e: any) => e.id == this.examinationForm.value.vr_lid_id)?.name || '',
        vr_conjuctiva_id :   this.conjunctiveList.find( (e: any) => e.id == this.examinationForm.value.vr_conjuctiva_id)?.name || '',
        vr_cornea_id :  this.corneaList.find( (e: any) => e.id == this.examinationForm.value.vr_cornea_id)?.name || '',
        vr_ac_id :  this.acList.find( (e: any) => e.id == this.examinationForm.value.vr_ac_id)?.name || '',
        vr_pupil_id :   this.pupilList.find( (e: any) => e.id == this.examinationForm.value.vr_pupil_id)?.name || '',
        vr_lens_id :   this.lensList.find( (e: any) => e.id == this.examinationForm.value.vr_lens_id)?.name || '',
        vr_vitreous :    this.examinationForm.value.vr_vitreous || '',
        vr_fundus :    this.examinationForm.value.vr_fundus || '',
        vr_iop :   this.examinationForm.value.vr_iop || '',
        vr_retina :  this.examinationForm.value.vr_retina || '',
        vl_glasses_id :  this.glassesList.find( (e: any) => e.id == this.examinationForm.value.vl_glasses_id)?.name || '',
        vl_lid_id :  this.lidList.find( (e: any) => e.id == this.examinationForm.value.vl_lid_id)?.name || '',
        vl_conjuctiva_id :  this.conjunctiveList.find( (e: any) => e.id == this.examinationForm.value.vl_conjuctiva_id)?.name || '' ,
        vl_cornea_id :  this.corneaList.find( (e: any) => e.id == this.examinationForm.value.vl_cornea_id)?.name || '',
        vl_ac_id :  this.acList.find( (e: any) => e.id == this.examinationForm.value.vl_ac_id)?.name || '',
        vl_pupil_id :  this.pupilList.find( (e: any) => e.id == this.examinationForm.value.vl_pupil_id)?.name || '',
        vl_lens_id :  this.lensList.find( (e: any) => e.id == this.examinationForm.value.vl_lens_id)?.name || '',
        vl_vitreous :  this.examinationForm.value.vl_vitreous || '',
        vl_fundus :  this.examinationForm.value.vl_fundus || '',
        vl_iop :  this.examinationForm.value.vl_iop || '',
        vl_retina :  this.examinationForm.value.vl_retina || '',
        beneficiary_id :  this.benID
    }

    // Check all relevant values
     const isPrescrEmpty = Object.entries(this.forPrescritionData).filter(([key, value]) =>
      key !== 'beneficiary_id' && !(key.endsWith('_id') && value === 0) )
      .every(([_, value]) => value === null || value === '' || value === undefined);

       if (isPrescrEmpty) {
         this.forPrescritionData = null;
      }

  }
}



